/*@flow*/
import type { State, Action } from './types';
import * as I from 'immutable';
import setIn from 'lib/setIn';

type NewPayload = { resource: Object, resourceName: string };
type EditPayload = { id: ID, resourceName: string };

export default (state: I.RecordOf<State>, action: Action) => {
  const { type, payload } = action;
  let newState: I.RecordOf<State> = state;

  switch (type) {
    case 'RESET':
      newState = newState
        .set('mode', 'WIZARD')
        .set('resourceName', '')
        .update('resource', v => v.clear());
      break;
    case 'SELECT_RESOURCE':
      if (payload) {
        newState = newState
          .set('mode', 'WIZARD_FORM')
          .set('portalMode', 'OPEN')
          .set('resourceName', payload);
      }
      break;
    case 'OPEN_WIZARD':
      newState = newState.set('mode', 'WIZARD').set('portalMode', 'OPEN');
      break;
    case 'CLOSE_WIZARD':
      newState = newState.clear();
      break;
    case 'NEW_RESOURCE':
      if (payload) {
        newState = newState
          .set('mode', 'RESOURCE_FORM')
          .set('portalMode', 'OPEN')
          .set('resourceName', (payload: NewPayload).resourceName)
          .setIn(['resource'], I.Map((payload: NewPayload).resource));
      }
      break;
    case 'EDIT_RESOURCE':
      if (payload) {
        newState = newState
          .set('mode', 'RESOURCE_FORM')
          .set('portalMode', 'OPEN')
          .set('resourceName', (payload: EditPayload).resourceName)
          .setIn(['resource', 'id'], (payload: EditPayload).id);
      }
      break;
    case 'DUP_RESOURCE':
      if (payload) {
        newState = newState
          .set('mode', 'DUP_FORM')
          .set('portalMode', 'OPEN')
          .set('resourceName', (payload: EditPayload).resourceName)
          .setIn(['resource', 'id'], (payload: EditPayload).id);
      }
      break;
    case 'START_INTEGRATION':
      newState = newState.set('mode', 'INTEGRATION').set('portalMode', 'OPEN');
      break;
    case 'SET_RECORD':
      if (payload) {
        newState = setIn(newState)(payload);
      }
      break;
    default:
      throw new Error('Unrecognized action `' + type + '`');
  }
  return newState;
};
